export const fmt = (d) => (d ? new Date(d).toLocaleString() : '—')
export const norm = (s) => String(s ?? '').trim().toLowerCase()